module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAcCAYAAADiHqZbAAAACXBIWXMAAAsSAAALEgHS3X78AAAAe0lEQVRYhe3XMQ5AUBCE4VnxaqJ3D1G5khNSOoFjCBLVk6xQ0k3jFfM302zxtWtWtwPSrM8BdKFoktKdxww/9/LGwUL1OfgzswAHkCWleiUcm3BswrEJxyYcm3BswrEJxyYcm3BswrE9f6vHJSmUe3z2xo1xm34HfQLWC/88E3t6i87jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-blue-b-2.png
// module id = 264
// module chunks = 0